import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {Auth} from './auth.service';
import {JWT_TOKEN_KEY} from "../_constants/common.constant";
import {UiHelper} from "../_helpers/ui.helper";

@Injectable({providedIn: 'root'})
export class AuthGuard implements CanActivate {
  private ui = UiHelper;
  constructor(private auth: Auth, private router: Router) {}
  canActivate(x: ActivatedRouteSnapshot, y: RouterStateSnapshot): boolean {
    if (this.auth.loggedIn()) {
      return true;
    }else {
      if (localStorage.getItem(JWT_TOKEN_KEY)) {
        localStorage.removeItem(JWT_TOKEN_KEY);
      }
      this.router.navigate([this.ui.absoluteUrl('/landing')], {queryParams: {next: y.url}}).then(() => {
        window.location.reload();
      });

      return false;
    }
  }
}
